import { useEffect } from 'react';
import { useTranslation } from '../i18n';

/**
 * «شروع · پارسینا» — the browser tab title for a screen.
 *
 * `docs/CLINIC_MULTI_CLINIC_UX_REV2.md` §A15 makes the tab title carry the
 * screen, then the clinic, then the brand, and hands the job to `ClinicLayout`.
 * That layout is not mounted on the pre-membership screens — «شروع», the
 * registration wizard and the invitation landing all render OUTSIDE the shell,
 * because there is no clinic to put in a sidebar — so those screens kept
 * whatever title the previous page happened to leave behind. With two tabs on
 * two clinics being routine, a tab that still says «پذیرش · کلینیک مهر» while
 * showing the registration wizard is actively misleading.
 *
 * There is no clinic segment here on purpose: a person on these screens has
 * not entered one, and naming a clinic they cannot enter would be the same
 * false claim in a smaller place.
 *
 * The previous title is restored on unmount so a screen that borrows the tab
 * for the length of a dialog hands it back.
 */
export default function usePageTitle(title) {
  const { t } = useTranslation();
  useEffect(() => {
    if (!title) return undefined;
    const previous = document.title;
    document.title = `${title} · ${t('common.brand.name')}`;
    return () => { document.title = previous; };
  }, [title, t]);
}
